/**
 * Returns a cookie string from a cookie config
 *
 * Does not perform any value-escaping or sanitization
 */
const serializeCookie = ({ name, value, ...rest }) => name +
    "=" +
    value +
    ";" +
    Object.entries(rest)
        .map(([key, value]) => (value === true ? key : key + "=" + value))
        .join(";");

export { serializeCookie };
